import PropTypes from "prop-types"

export const FACET = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  selected: PropTypes.bool.isRequired,
})

export const TIER = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  facets: PropTypes.objectOf(FACET),
  level: PropTypes.number.isRequired,
})

export const SELECTED_FACET = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
})

export const CLASSIFICATION = PropTypes.objectOf(TIER)
export const SELECTED_CLASSIFICATION = PropTypes.arrayOf(SELECTED_FACET)

export const FACET_TYPE = PropTypes.shape({
  type: PropTypes.string.isRequired,
  facets: PropTypes.oneOfType([
    PropTypes.arrayOf(FACET),
    PropTypes.objectOf(CLASSIFICATION),
  ]),
  selected: PropTypes.oneOfType([
    PropTypes.arrayOf(FACET),
    PropTypes.objectOf(SELECTED_CLASSIFICATION),
  ]),
})
